import { useDisclosure } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { BsPencil } from "react-icons/bs";
import { FaEye } from "react-icons/fa";
import { MdOutlineDeleteForever } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { DeleteModal } from "../Modals/DeleteModal";
import ExpertDataService from "../../services/Expert";
import { IoIosSend } from "react-icons/io";
import { SendSyncCalendarEmailModal } from "../Modals/SendSyncCalendarEmailModal";
import { ClipLoader } from "react-spinners";

export const SingleExpertRow = ({
  props,
  func,
  id,
  calendarSyncStatuses,
}: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    is_hidden,
    is_archived,
    allow_app_registration,
    full_name,
    whatsapp_phone_number,
    personal_email_id,
    city,
    role,
    google_info,
  } = props;

  const googleSyncStatus = calendarSyncStatuses?.find(
    (s: any) => s.id === id
  )?.synced;

  // console.log(personal_email_id,google_info.calendar.refresh_token);

  const navigate = useNavigate();
  const [modal, setModal] = useState("");
  const [archivedStatus, setArchivedStatus] = useState(is_archived);

  const archiveExpert = async () => {
    try {
      const archive = !archivedStatus;

      await ExpertDataService.updateArchiveStatus(id, archive);

      setArchivedStatus(!archivedStatus);
    } catch (error) {
      console.error("Failed to update archived status", error);
    }
  };

  return (
    <tr>
      <td>
        <div
          className="edit-icon"
          onClick={() => navigate(`/experts/edit/${id}`)}
        >
          <BsPencil />
        </div>
      </td>
      <td>
        <div className="edit-icon">
          <input type="checkbox" aria-label="Checkbox" checked={is_hidden} />
        </div>
      </td>
      <td>
        <div className="edit-icon">
          <input
            type="checkbox"
            aria-label="Checkbox"
            checked={allow_app_registration}
          />
        </div>
      </td>
      <td>{full_name}</td>
      <td>{whatsapp_phone_number}</td>
      <td>{personal_email_id}</td>
      <td> {role} </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => navigate(`/experts/view/${id}`)}
          >
            <FaEye style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className={archivedStatus ? "disabledButton" : "btn"}
            onClick={() => archiveExpert()}
            // disabled={archivedStatus}
            style={
              archivedStatus
                ? { color: "#fdb508", fontWeight: "bolder" }
                : { backgroundColor: "#fdb508", color: "white" }
            }
          >
            {archivedStatus ? "Archived" : "Archive"}
          </button>
        </div>
      </td>

      <td>
        <div className="d-flex flex-column align-items-center">
          <div className="d-flex flex-column align-items-center">
            <span title="Send Email">
              <IoIosSend
                className="pointer"
                onClick={() => {
                  setModal("syncemailmodal");
                  onOpen();
                }}
              />
            </span>
            {google_info.calendar.refresh_token &&
              (!googleSyncStatus && googleSyncStatus !== null ? (
                <ClipLoader color="#327171" size={20} />
              ) : (
                <span
                  className={`mt-1 small ${
                    googleSyncStatus ? "text-success" : "text-danger"
                  }`}
                  style={{ fontSize: "0.75rem" }}
                >
                  {googleSyncStatus ? "Synced" : "Expired"}
                </span>
              ))}
          </div>
        </div>
      </td>

      {modal === "deletemodal" && (
        <DeleteModal isOpen={isOpen} onClose={onClose} func={func} id={id} />
      )}

      {modal === "syncemailmodal" && (
        <SendSyncCalendarEmailModal
          isOpen={isOpen}
          onClose={onClose}
          email={personal_email_id}
        />
      )}
      {/* AddCommentModal */}
    </tr>
  );
};
